var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-len */
import React from "react";
import id from "@irati/utils/id";
import BaseSvgIcon from "./Base";
var AddComment = function (props) {
    var titleId = id("title", props);
    var title = props.title, rest = __rest(props, ["title"]);
    return (React.createElement(BaseSvgIcon, __assign({}, rest, { "aria-labelledby": titleId }),
        React.createElement("title", { id: titleId }, title),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { height: "18", rx: "1", width: "18" }),
            React.createElement("g", { fill: "currentColor" },
                React.createElement("rect", { height: "1", rx: ".5", width: "7", y: "3" }),
                React.createElement("rect", { height: "7", rx: ".5", width: "1", x: "3" }),
                React.createElement("rect", { height: "1", rx: ".5", width: "6", x: "5.5", y: "5.5" }),
                React.createElement("rect", { height: "1", rx: ".5", width: "6", x: "7", y: "8" })),
            React.createElement("path", { d: "m8.99493813 1.5c4.10648697 0 7.49999997 2.5451348 7.49999997 5.79545455 0 1.15777909-.4366338 2.25966611-1.2325726 3.19323125-.0280446.0451667-.062397.0887022-.1034909.1297961l-.174238.1741762c-.0494695.0502205-.0494695.0502205-.0943581.0944199l-5.41322211 5.4132221c-.4295215.4295215-1.16393645.1253168-1.16393645-.4821183v-2.7508322c-2.77119949-.1923552-5.1320135-1.7404626-6.20325666-3.53545228", fillRule: "nonzero", stroke: "currentColor", strokeLinecap: "round" }))));
};
AddComment.defaultProps = {
    id: "add-comment-icon",
    title: "Add a comment"
};
export default AddComment;
